// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.freemium.analytics.RentalManagerUserFreemiumAnalyticsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserFreemiumAnalyticsWebApiHandler_audience,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_Path,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_comps,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_Path,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_Path,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_overview,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_Path,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_Path,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_Path,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_prices,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_Path,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance,
  RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  FreemiumAnalyticsInquiriesResponseWebDto,
  FreemiumAnalyticsOverviewResponseWebDto,
  FreemiumAnalyticsPageViewsResponseWebDto,
  FreemiumAnalyticsPopularAttributesResponseWebDto,
  FreemiumAnalyticsPricingGuidanceResponseWebDto,
  ListingAlias,
  PropertyType,
  RentalManagerFreemiumAnalyticsFilterType,
  UserFreemiumAnalyticsAudienceResponseWebDto,
  UserFreemiumAnalyticsCompsResponseWebDto,
  UserFreemiumAnalyticsPricesResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface AudienceParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface CompsParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface InquiriesParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface OverviewParams {
  beds?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
}
interface PageViewsParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface PopularAttributesParams {
  beds?: number;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface PricesParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface PricingGuidanceParams {
  listingAlias: ListingAlias;
  useTestData?: boolean;
}

export type RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_Options = UseQueryOptions<
  UserFreemiumAnalyticsAudienceResponseWebDto,
  unknown,
  UserFreemiumAnalyticsAudienceResponseWebDto,
  readonly [string, AudienceParams]
>;

const RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_GetKey = (getParams: AudienceParams) =>
  [RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_Path, getParams] as const;

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_queryOptions = (
  getParams: AudienceParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumAnalyticsWebApiHandler_audience(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get audience analytics
 */
export const useRentalManagerUserFreemiumAnalyticsWebApiHandler_audience = (
  getParams: AudienceParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumAnalyticsWebApiHandler_audience.getKey =
  RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_GetKey;

export type RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_Options = UseQueryOptions<
  UserFreemiumAnalyticsCompsResponseWebDto,
  unknown,
  UserFreemiumAnalyticsCompsResponseWebDto,
  readonly [string, CompsParams]
>;

const RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_GetKey = (getParams: CompsParams) =>
  [RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_Path, getParams] as const;

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_queryOptions = (
  getParams: CompsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumAnalyticsWebApiHandler_comps(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get comps
 */
export const useRentalManagerUserFreemiumAnalyticsWebApiHandler_comps = (
  getParams: CompsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumAnalyticsWebApiHandler_comps.getKey =
  RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_GetKey;

export type RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_Options = UseQueryOptions<
  FreemiumAnalyticsInquiriesResponseWebDto,
  unknown,
  FreemiumAnalyticsInquiriesResponseWebDto,
  readonly [string, InquiriesParams]
>;

const RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_GetKey = (getParams: InquiriesParams) =>
  [RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_Path, getParams] as const;

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_queryOptions = (
  getParams: InquiriesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get inquiries
 */
export const useRentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries = (
  getParams: InquiriesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries.getKey =
  RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_GetKey;

export type RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_Options = UseQueryOptions<
  FreemiumAnalyticsOverviewResponseWebDto,
  unknown,
  FreemiumAnalyticsOverviewResponseWebDto,
  readonly [string, OverviewParams]
>;

const RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_GetKey = (getParams: OverviewParams) =>
  [RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_Path, getParams] as const;

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_queryOptions = (
  getParams: OverviewParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumAnalyticsWebApiHandler_overview(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get overview
 */
export const useRentalManagerUserFreemiumAnalyticsWebApiHandler_overview = (
  getParams: OverviewParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumAnalyticsWebApiHandler_overview.getKey =
  RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_GetKey;

export type RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_Options = UseQueryOptions<
  FreemiumAnalyticsPageViewsResponseWebDto,
  unknown,
  FreemiumAnalyticsPageViewsResponseWebDto,
  readonly [string, PageViewsParams]
>;

const RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_GetKey = (getParams: PageViewsParams) =>
  [RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_Path, getParams] as const;

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_queryOptions = (
  getParams: PageViewsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get page views
 */
export const useRentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews = (
  getParams: PageViewsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews.getKey =
  RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_GetKey;

export type RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_Options = UseQueryOptions<
  FreemiumAnalyticsPopularAttributesResponseWebDto,
  unknown,
  FreemiumAnalyticsPopularAttributesResponseWebDto,
  readonly [string, PopularAttributesParams]
>;

const RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_GetKey = (getParams: PopularAttributesParams) =>
  [RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_Path, getParams] as const;

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_queryOptions = (
  getParams: PopularAttributesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get popular attributes analytics
 */
export const useRentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes = (
  getParams: PopularAttributesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes.getKey =
  RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_GetKey;

export type RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_Options = UseQueryOptions<
  UserFreemiumAnalyticsPricesResponseWebDto,
  unknown,
  UserFreemiumAnalyticsPricesResponseWebDto,
  readonly [string, PricesParams]
>;

const RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_GetKey = (getParams: PricesParams) =>
  [RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_Path, getParams] as const;

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_queryOptions = (
  getParams: PricesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumAnalyticsWebApiHandler_prices(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get price
 */
export const useRentalManagerUserFreemiumAnalyticsWebApiHandler_prices = (
  getParams: PricesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumAnalyticsWebApiHandler_prices.getKey =
  RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_GetKey;

export type RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_Options = UseQueryOptions<
  FreemiumAnalyticsPricingGuidanceResponseWebDto,
  unknown,
  FreemiumAnalyticsPricingGuidanceResponseWebDto,
  readonly [string, PricingGuidanceParams]
>;

const RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_GetKey = (getParams: PricingGuidanceParams) =>
  [RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_Path, getParams] as const;

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_queryOptions = (
  getParams: PricingGuidanceParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get pricing guidance
 */
export const useRentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance = (
  getParams: PricingGuidanceParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance.getKey =
  RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_GetKey;
